// NewMortgageLoanForm.js
import React, {useEffect, useState} from 'react';
import axios from "axios";
import {useNavigate} from "react-router-dom";

// Get api's setup now
// Get form submission corrected and working

const NewHelocForm = () => {
    const [bankLoanNumber, setBankLoanNumber] = useState(null);
    const [lenderChoices, setLenderChoices] = useState([]);
    const [selectedLender, setSelectedLender] = useState('');
    const [initialCreditLimit, setInitialCreditLimit] = useState(null);
    // const [rateTypeChoices, setRateTypeChoices] = useState([]);
    // const [selectedRateType, setSelectedRateType] = useState('FLOAT');
    // const [baseRateChoices, setBaseRateChoices] = useState([]);
    const [selectedBaseRate, setSelectedBaseRate] = useState('');
    // const [annualInterestRate, setAnnualInterestRate] = useState(null);
    const [originationDate, setOriginationDate] = useState(null);
    // const [firstPaymentDate, setFirstPaymentDate] = useState(null);
    const [loanTermYears, setLoanTermYears] = useState('');
    const [noPaymentsPerYear, setNoPaymentsPerYear] = useState(12);
    const [totalClosingCosts, setTotalClosingCosts] = useState(null);
    const [linkedPropertyChoices, setLinkedPropertyChoices] = useState([]);
    const [selectedLinkedProperty, setSelectedLinkedProperty] = useState('');

    const [error, setError] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        const fetchLenderChoices = async () => {
            try {
                const response = await axios.get('/api/balance_sheet/financing/lender-choices/');
                setLenderChoices(response.data);
            } catch (error) {
                console.error('Error fetching lender choices:', error);
                setError('Failed to fetch lender choices.');
            }
        };
        fetchLenderChoices();
    }, []);

    // useEffect(() => {
    //     const fetchRateTypeChoices = async () => {
    //         try {
    //             const response = await axios.get('/api/balance_sheet/financing/rate-type-choices/');
    //             setRateTypeChoices(response.data);
    //         } catch (error) {
    //             console.error('Error fetching rate type choices:', error);
    //             setError('Failed to fetch rate type choices.');
    //         }
    //     };
    //     fetchRateTypeChoices();
    // }, []);

        useEffect(() => {
        const fetchPropertyChoices = async () => {
            try {
                const response = await axios.get('/api/balance_sheet/assets/physical_assets/property-choices/');
                setLinkedPropertyChoices(response.data);
            } catch (error) {
                console.error('Error fetching lender choices:', error);
                setError('Failed to fetch lender choices.');
            }
        };
        fetchPropertyChoices();
    }, []);

    // Handle form submit
    const handleSubmit = async (event) => {
        event.preventDefault();

        const newHelocData = {
            'account_number': bankLoanNumber,
            'revolver_type': 'heloc',
            'lender': selectedLender,
            'amount': initialCreditLimit,
            'base_rate_type': selectedBaseRate,
            // 'initial_interest_rate': annualInterestRate,
            'origination_date': originationDate,
            // 'first_payment_date': firstPaymentDate,
            'term_in_years': loanTermYears,
            'n_payments_per_year': noPaymentsPerYear,
            'total_closing_costs': totalClosingCosts,
            'residential_property': selectedLinkedProperty,
        }
        console.log(newHelocData)
        try {
            const response = await axios.post('/api/balance_sheet/financing/revolvers/helocs/', newHelocData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            navigate(`/balance_sheet/assets/physical_assets/financing/revolvers/helocs/${response.data.id}/`);
            // setResiPropertyId(response.data.id);


            // Now you can toggle visibility for land and structure forms
        } catch (error) {
            console.error('Error creating new heloc loan:', error);
            setError('There was an error creating the heloc loan. Please check your input.');
        }
    };



  return (
        <div className="container mt-4" style={{margin: 0, padding: '20px', maxWidth: '70%'}}>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="lender" className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>Lender:</label>
                    <select
                        id="lender"
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        value={selectedLender}
                        onChange={(e) => setSelectedLender(e.target.value)}
                        required
                    >
                        <option value="" disabled>Select a lender</option>
                        {lenderChoices.map(([id, name]) => (
                            <option key={id} value={id}>{name}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>Loan Number:</label>
                    <input
                        type="number"
                        value={bankLoanNumber}
                        onChange={(e) => setBankLoanNumber(parseInt(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>Credit Limit:</label>
                    <input
                        type="number"
                        value={initialCreditLimit}
                        onChange={(e) => setInitialCreditLimit(parseFloat(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>

                {/*<div className="form-group">*/}
                {/*    <label htmlFor="rateType" className="text-right d-inline-block"*/}
                {/*           style={{width: '200px', textAlign: 'right'}}>Interest Rate Type:</label>*/}
                {/*    <select*/}
                {/*        id="rateType"*/}
                {/*        className="form-control d-inline-block"*/}
                {/*        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}*/}
                {/*        value={selectedRateType}*/}
                {/*        onChange={(e) => setSelectedRateType(e.target.value)}*/}
                {/*        required*/}
                {/*    >*/}
                {/*        <option value="" disabled>Select a rate type</option>*/}
                {/*        {rateTypeChoices.map(([value, label]) => (*/}
                {/*            <option key={value} value={value}>{label}</option>*/}
                {/*        ))}*/}
                {/*    </select>*/}
                {/*</div>*/}

                {/*<div className="form-group">*/}
                {/*    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Initial*/}
                {/*        Interest Rate (%):</label>*/}
                {/*    <input*/}
                {/*        type="number"*/}
                {/*        value={annualInterestRate}*/}
                {/*        onChange={(e) => setAnnualInterestRate(parseFloat(e.target.value))}*/}
                {/*        className="form-control d-inline-block"*/}
                {/*        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}*/}
                {/*        required*/}
                {/*    />*/}
                {/*</div>*/}

                <div className="form-group">
                      <label htmlFor="baseRate" className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>Base Rate Type:</label>
                      <select
                        id="baseRateType"
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        value={selectedBaseRate}
                        onChange={(e) => setSelectedBaseRate(e.target.value)}
                        required
                      >
                        <option value="prime">Prime</option>
                        <option value="treasury_10_yr">10 Yr. Treasury</option>
                      </select>
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>Origination Date:</label>
                    <input
                        type="date"
                        value={originationDate}
                        onChange={(e) => setOriginationDate(e.target.value)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Loan Term
                        (Years):</label>
                    <input
                        type="number"
                        value={loanTermYears}
                        onChange={(e) => setLoanTermYears(parseFloat(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>

                {/*<div className="form-group">*/}
                {/*    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>First Payment Date:</label>*/}
                {/*    <input*/}
                {/*        type="date"*/}
                {/*        value={firstPaymentDate}*/}
                {/*        onChange={(e) => setFirstPaymentDate(e.target.value)}*/}
                {/*        className="form-control d-inline-block"*/}
                {/*        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}*/}
                {/*    />*/}
                {/*</div>*/}

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Number of
                        Payments (per year):</label>
                    <input
                        type="number"
                        value={noPaymentsPerYear}
                        onChange={(e) => setNoPaymentsPerYear(parseInt(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>Loan Closing Costs ($):</label>
                    <input
                        type="number"
                        value={totalClosingCosts}
                        onChange={(e) => setTotalClosingCosts(parseFloat(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="property" className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>Property:</label>
                    <select
                        id="lender"
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        value={selectedLinkedProperty}
                        onChange={(e) => setSelectedLinkedProperty(e.target.value)}
                        required
                    >
                        <option value="" disabled>Select a property</option>
                        {linkedPropertyChoices.map(item => (
                            <option key={item.id} value={item.id}>{item.address}</option>
                        ))}
                    </select>
                </div>

            <div style={{ marginTop: '20px', marginRight: '20px', textAlign: 'right' }}>
                <button type="submit" className="btn btn-primary">Submit</button>
            </div>
            </form>

            {error && <div className="text-danger">{error}</div>} {/* Display error messages */}
        </div>
    );
};
export default NewHelocForm;